import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {
  SuperMarketUploadBudgetDialogComponent
} from '../../dialogs/super-market-upload-budget-dialog/super-market-upload-budget-dialog.component';
import {MatPaginator, MatTableDataSource} from '@angular/material';
import {SuperMarketRefrigeratorBudgetService} from '../../../services/super-market-refrigerator-budget.service';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {
  SuperMarketBudgetFileInfoDialogComponent
} from '../../dialogs/super-market-budget-file-info-dialog/super-market-budget-file-info-dialog.component';


@Component({
  selector: 'app-sm-settings',
  templateUrl: './sm-settings.component.html'
})

export class SMSettingsComponent implements OnInit {
  @ViewChild('paginator', {static: false}) paginator: MatPaginator;

  public dataSource: MatTableDataSource<any>;
  public displayedColumns: string[];
  public isLoading: boolean;
  public tableHeight: number;

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private superMarketBudgetService: SuperMarketRefrigeratorBudgetService,
              private toastMessagesService: ToastMessagesService) {
    this.dataSource = new MatTableDataSource<any>([]);
    this.displayedColumns = [
      'id',
      'original_name',
      'date_uploaded',
      'is_active_name',
      'actions'
    ];
    this.isLoading = false;
    this.tableHeight = window.innerHeight - 320;
  }

  async ngOnInit(): Promise<void> {
    try {
      this.isLoading = true;
      await this.initDatabase();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.error.message);
    } finally {
      this.commonService.setPaginatorTexts(this.paginator);
      this.isLoading = false;
    }
  }

  public browseFiles() {
    const dialog = this.matDialog.open(SuperMarketUploadBudgetDialogComponent, {});
    dialog.afterClosed().subscribe(async response => {
      if (response) {
        await this.initDatabase();
      }
    });
  }

  private async initDatabase(): Promise<void> {
    this.dataSource = new MatTableDataSource<any>(await this.superMarketBudgetService.fetchUploadedBudgetFiles() as any[]);
    this.dataSource.paginator = this.paginator;
  }

  async setActivity($event: any, record: any) {
    try {
      this.isLoading = true;
      await this.superMarketBudgetService.setFileActivityStatus(record.id, record.is_active === 1 ? 0 : 1);
      const data = this.dataSource.data;
      const currentRecord = data.find(r => r.id === record.id);
      currentRecord.is_active = record.is_active === 1 ? 0 : 1;
      currentRecord.is_active_name = record.is_active === 1 ? 'ΕΝΕΡΓΟ' : 'ΑΝΕΝΕΡΓΟ';
      this.dataSource.data = data;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.error.message);
    } finally {
      this.isLoading = false;
    }
  }


  public showInfo(row: any): void {
    this.matDialog.open(SuperMarketBudgetFileInfoDialogComponent, {
      data: {
        rowId: row.id
      }
    });
  }


}
